// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { Button, Toastr, NumberInput, Loader } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";

// Internal Imports
import { BILLING } from "../../constants";
import { GlobalUtils } from "../../utils";

// Action Imports
import { getSubscriptionCheckoutSessionID } from "../../actions/SettingsActions/settingsActions";

// Service import
import { getBillingInfo } from "../../actions/SettingsActions/settingsService";
import { sendFeatureRequest } from "../../actions/CommonActions/commonService";

// Destructuring
const { PRICING_PLAN_STRIPE_MENU_FOR_SUBSCRIPTION } = BILLING;
const { readDataFromLocalStorage } = GlobalUtils;

class ShowEsignLimitIncreaseRequestPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toogleStatus: true,
      billingInfo: null,
      showLoader: true,
      phoneNumber: "",
    };
  }

  componentDidMount() {
    this._getBillingInfo();
  }

  _getBillingInfo = () => {
    getBillingInfo()
      .then(response => {
        this.setState({ billingInfo: response, showLoader: false });
      })
      .catch(err => {
        console.error(`NavBar => CDM => ${err}`);
      });
  };

  _onPhoneNumberChange = value => {
    this.setState({
      phoneNumber: value,
    });
  };

  _onSubmit = () => {
    const userSignUpInfo = readDataFromLocalStorage("userSignUpInfo");
    const body = `A user just requested a callback to increase E-sign limit. Phone: ${
      this.state.phoneNumber
    }.
    The user's current plan is ${userSignUpInfo.billing_plan}`;
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    const {
      first_name: firstName,
      last_name: lastName,
      user_email: userEmail,
      organisation,
    } = CURRENT_USER;
    const data = {
      email: userEmail,
      orgname: organisation,
      subject: `Increase E-Sign limit call back request - Current plan: ${
        userSignUpInfo.billing_plan
      } `,
      body,
      username: `${firstName} ${lastName}`,
    };
    sendFeatureRequest(data)
      .then(() => {
        this.props.onClose();
        Toastr.showToastr({
          type: "success",
          message: "Successfully requested call back",
          timeout: 3000,
        });
      })
      .catch(err => {
        console.error("UpgradePopUp => _onSubmit", err);
      });
  };

  _updateToggleStatus = data => {
    this.setState({
      toogleStatus: data !== "Monthly",
    });
  };

  render() {
    if (this.state.showLoader) {
      return <Loader label="please wait" fullScreen />;
    }
    const { limit } = this.props.eSignCosumptionRecord;
    const mapBymonthlyOrAnnually = this.state.toogleStatus
      ? "annually"
      : "monthly";
    return (
      <Modal
        open
        onClose={this.props.onClose}
        center
        closeOnOverlayClick={false}
        className="">
        {this.state.billingInfo !== null &&
        this.state.billingInfo.subscription.status === "active" &&
        this.state.billingInfo.auto_downgraded === false ? (
          <div className="esignlimitincreaserequest-container">
            <section className="esignlimitincreaserequest-info-section">
              <div className="esignlimitincreaserequest-welcome-msg">
                You have used{" "}
                {this.props.eSignCosumptionRecord &&
                  this.props.eSignCosumptionRecord.limit}{" "}
                eSignatures in your plan.{" "}
              </div>
              <div className="esignlimitincreaserequest-upsale-msg">
                Please share your phone number with us to enable more
                eSignatures. We&apos;ll connect with you shortly to get more
                details and assist. You can also contact our support via the
                in-app chat or write to us at{" "}
                <span className="esignlimitincreaserequest-email-contact">
                  support@revv.so
                </span>
              </div>
            </section>

            <section className="esignlimitincreaserequest-callback-section">
              <div className="esignlimitincreaserequest-callback-txt">
                Please enter your phone number and we will get in touch with you
                soon
              </div>
              <div className="">
                <NumberInput
                  data-test="phoneNumber"
                  placeholder="Enter your phone number"
                  onChange={value => this._onPhoneNumberChange(value)}
                  value={this.state.phoneNumber}
                  autoFocus
                />
                <div className="esignlimitincreaserequest-callback-actions">
                  <Button
                    data-test="phoneNumber-submission"
                    className="btn btn-primary planchangerequest-submit-btn"
                    onClick={() => this._onSubmit()}
                    disabled={this.state.phoneNumber.length === 0}>
                    Submit
                  </Button>
                </div>
              </div>
            </section>
          </div>
        ) : (
          <div className="esignlimitincreaserequest-container">
            <section className="esignlimitincreaserequest-info-section">
              <div className="esignlimitincreaserequest-welcome-msg">
                You`re a fantastic closer! You used all {limit} eSignatures in
                your plan.{" "}
              </div>
              <div className="esignlimitincreaserequest-upsale-msg">
                Don`t slow down now. Upgrade now or buy more eSignatures to
                continue requesting eSignatures on documents.
              </div>
            </section>
            <div className="esignlimitincreaserequest-toogle-container">
              <span
                className={`esignlimitincreaserequest-plan-toogle-tab ${
                  !this.state.toogleStatus
                    ? "esignlimitincreaserequest-plan-toogle-selected-item"
                    : ""
                }`}
                role="button"
                tabIndex={0}
                onClick={() => this._updateToggleStatus("Monthly")}
                onKeyPress={() => {}}>
                Monthly
              </span>
              <span
                className={`esignlimitincreaserequest-plan-toogle-tab ${
                  this.state.toogleStatus
                    ? "esignlimitincreaserequest-plan-toogle-selected-item"
                    : ""
                }`}
                role="button"
                tabIndex={0}
                onClick={() => this._updateToggleStatus("Annually")}
                onKeyPress={() => {}}>
                Annually
              </span>
            </div>
            <div className="esignlimitincreaserequest-plans-saving-text">
              <i>
                {" "}
                <FontAwesomeIcon icon={["far", "badge-percent"]} />
              </i>
              Save upto 20% on Annual plans
            </div>
            <div className="esignlimitincreaserequest-plan-container">
              {PRICING_PLAN_STRIPE_MENU_FOR_SUBSCRIPTION[
                mapBymonthlyOrAnnually
              ].map(data => (
                <section
                  className={`esignlimitincreaserequest-plan-section ${
                    data.mostPopular ? "most-pupular" : ""
                  }`}>
                  {data.mostPopular && (
                    <div className="esignlimitincreaserequest-plan-most-popular">
                      Most popular
                    </div>
                  )}

                  <div className="esignlimitincreaserequest-plan-name">
                    {data.displayName}
                  </div>
                  <div className="esignlimitincreaserequest-plan-value">
                    {data.planPrice}
                    <span className="esignlimitincreaserequest-plan-value-month">
                      /month
                    </span>
                  </div>
                  <div className="esignlimitincreaserequest-plan-billed-period">
                    {data.yearlyPrice}
                  </div>
                  <div className="esignlimitincreaserequest-plan-subscribe-button">
                    <Button
                      data-test="plan-subscription"
                      className="plan-subscription-btn"
                      onClick={() =>
                        this.props.getSubscriptionCheckoutSessionID(
                          data.priceID,
                        )
                      }>
                      {data.buttonLabel}
                    </Button>
                  </div>
                  {data.featureEnabled.map(featureDetails => (
                    <div className="esignlimitincreaserequest-plan-feature-list">
                      <i>
                        {" "}
                        <FontAwesomeIcon icon={["far", "check-circle"]} />
                      </i>{" "}
                      {featureDetails}
                    </div>
                  ))}
                </section>
              ))}
            </div>
          </div>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = () => {};

const mapDispatchToProps = {
  getSubscriptionCheckoutSessionID,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ShowEsignLimitIncreaseRequestPopup);



// WEBPACK FOOTER //
// ./src/components/ShowEsignLimitIncreaseRequestPopup/index.js